<template>
    <p class="mb-3 text-[11px] font-semibold uppercase tracking-wider text-theme-text opacity-50">
        <slot />
    </p>
</template>

<script>
'use strict';

export default {
    name: 'SectionLabel',
};
</script>
